// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_ok-8";
export var editMode = "_ok-3";
export var headerRow = "_ok-a";
export var headerTitle = "_ok-b";
export var product = "_ok-1";
export var productDetails = "_ok-5";
export var productDivider = "_ok-7";
export var productImage = "_ok-2";
export var productInfo = "_ok-4";
export var productTitle = "_ok-6";
export var strikethrough = "_ok-9";
export var upsellProductsCard = "_ok-0";